import React, { Fragment } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import { Title, Text, CalendarIcon } from '../index';

import { StyledCard, StyledCardContent } from './style';

export const PatientDetailCard = ({ data }) => {
    const today = dayjs().format('YYYY-MM-DD');

    return (
        <StyledCard variant="outlined">
            <StyledCardContent>
                <Title style={{ fontSize: '16px' }}>Appointment Detail</Title>
                {data ? (
                    <Text $color="purple" style={{ fontSize: '14px', marginTop: '10px' }}>
                        {data?.session}
                    </Text>
                ) : (
                    <Skeleton width={150} height={30} variant="text" />
                )}
                <div
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        marginTop: '10px',
                    }}
                >
                    {data ? (
                        <Fragment>
                            <Text>
                                <CalendarIcon fill="pink" />
                            </Text>
                            <Text
                                $color="pink"
                                style={{
                                    fontSize: '14px',
                                    paddingTop: '2px',
                                    marginBottom: '5px',
                                    marginLeft: '5px',
                                }}
                            >
                                {`${
                                    data?.date === today
                                        ? 'Today'
                                        : dayjs(data?.date).format('DD MMM YYYY')
                                }, ${data?.startTime.slice(0, 5)} - ${data?.endTime.slice(0, 5)}`}
                            </Text>
                        </Fragment>
                    ) : (
                        <Skeleton width={250} height={30} variant="text" />
                    )}
                </div>

                {data ? (
                    <Fragment>
                        <Text $color="pink" style={{ fontSize: '14px', marginTop: '10px' }}>
                            Appointment Agenda
                        </Text>
                        <Text style={{ fontSize: '14px', marginTop: '10px' }}>
                            {data?.meet?.name}
                        </Text>
                    </Fragment>
                ) : (
                    <Fragment>
                        <Skeleton width={250} height={30} variant="text" />
                        <Skeleton width={300} height={30} variant="text" />
                    </Fragment>
                )}
            </StyledCardContent>
        </StyledCard>
    );
};

PatientDetailCard.propTypes = {
    data: PropTypes.object,
};
